const FORM_RESPONSE_OPTIMIZE_ACTIONS = [
	"form/out/load",
	"form/out/checkFormSettings",
	"form/out/view",
	"form/out/signup",
];

export const withFormResponseOptimizeVer = (
	params: Record<string, unknown>,
	action: string,
	_companyUUID: string,
) => {
	if (!FORM_RESPONSE_OPTIMIZE_ACTIONS.includes(action)) {
		return params;
	}
	// 前端推全返回体优化，后端仅根据 ver 标记决定是否启用瘦身响应
	params.ver = "1";
	return params;
};
